<template>
  <ais-clear-refinements
    :excludedAttributes="$store.state.excludedClearRefinements"
  >
    <template v-slot="{ refine, createURL }">
      <a :href="createURL()" @click.prevent="refine" class="font-weight-normal">
        {{ text }}
      </a>
    </template>
  </ais-clear-refinements>
</template>

<script>
import { AisClearRefinements } from 'vue-instantsearch';

export default {
  components: {
    AisClearRefinements,
  },
  props: {
    text: String,
  },
};
</script>
